import React from 'react';

class IconTwitterComponent extends React.Component {
  render() {
    const { className, color = 'currentColor' } = this.props;

    return (
      <svg
        className={className}
        width="22"
        height="20"
        viewBox="0 0 22 20"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
      >
        <path
          d="M6.919 19.166c8.302 0 12.842-7.052 12.842-13.168 0-.2-.004-.4-.013-.598A9.281 9.281 0 0022 3.003a8.862 8.862 0 01-2.592.73 4.632 4.632 0 001.985-2.561 8.907 8.907 0 01-2.866 1.123A4.457 4.457 0 0015.232.833c-2.493 0-4.514 2.073-4.514 4.628 0 .363.04.716.117 1.055-3.751-.193-7.078-2.035-9.305-4.835a4.705 4.705 0 00-.61 2.326c0 1.606.797 3.023 2.009 3.852A4.398 4.398 0 01.884 7.28v.06c0 2.241 1.555 4.112 3.62 4.537a4.451 4.451 0 01-2.038.079c.575 1.839 2.24 3.177 4.217 3.214A8.912 8.912 0 010 17.088a12.55 12.55 0 006.919 2.08"
          fill={color}
          fillRule="nonzero"
        />
      </svg>
    );
  }
}

export default IconTwitterComponent;
